import React from "react";
import useProductInfo from "../../context/ProductInfoProvider";
import {ProductSelectionGroup} from "@/data/entities/cart";
import ProductOptionGroup from "@widgets/pos/order/menu/product/options/groups/ProductOptionGroup";


const ProductOptionGroups = () => {
    const {productSelection} = useProductInfo();

    if (productSelection.groups.length === 0) {
        return <></>;
    }

    return (
        <ol className={"pt-3 border-t flex flex-col gap-6 border-gray-200 dark:border-slate-700"}>
            {productSelection.groups.map((group: ProductSelectionGroup, index: number) =>
                <ProductOptionGroup
                    key={index}
                    group={group}
                />
            )}
        </ol>
    );
};

export default ProductOptionGroups;